<template>
  <el-cascader
    :options="options"
    :placeholder="inputPlaceholder || $t('app.pleaseSelectProvinceCity')"
    @change="changeProduct"
    :props="myProps"
    clearable
    v-model="result"
    ref="cascader"
    id="danganArea"
  ></el-cascader>
</template>

<script>
import { getBasicUrls } from "@/util/config";
import axios from "axios";
import { areaTree } from "@/api/CaseManage";
export default {
  data() {
    return {
      options: [],
      result: [],
      streetList: [],
      myProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level } = node; // node 节点数据
          const nodes = []; // 动态节点
          let type = level == 0 ? "110000" : node.value; // 0 代表第一次请求
          axios({
            method: "GET",
            url: getBasicUrls().schoolmApi + `/manage/base/area/${type}`,
          })
            .then((res) => {
              res.data.map((item) => {
                let area = {
                  value: item.id,
                  label: item.name,
                  leaf: node.level >= 3,
                };
                nodes.push(area);
              });
              resolve(nodes); // 回调
            })
            .catch((error) => {
              console.log(error);
            });
        },
      },
    };
  },
  watch: {
    DefaultValue: {
      handler(newVal, oldVal) {
        this.result = newVal;
      },
      immediate: true,
			deep: true
    },
  },
  props: {
    inputPlaceholder: {
      type: String,
      default: "",
    },
    prop: {
      type: String,
      default: "",
    },
    DefaultValue: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    // 切换商品类型
    changeProduct(node) {
      if (node.length > 0) {
        this.result = node;
      } else {
        this.result = [];
      }
      this.$emit("changeP", node);
    },
    async initOptions() {
      let list = [];
      if (list.length <= 0) {
        await areaTree({}).then((ret) => {
          if (ret.code === 0) {
            list = ret.data || [];
          }
        });
      }
      list = list.map((item) => {
        let obj = {
          label: item.name,
          value: item.code,
        };
        return obj;
      });
      this.options = list;
    },
    resetCascaderInput() {
      this.result = [];
    },
  },
  mounted() {
    this.initOptions();
  },
};
</script>

<style lang="scss" scoped></style>
